import axios from "axios";
import { loginFailure, loginStart, loginSuccess } from "./AuthActions";

export const login = async (user, dispatch) => {
  dispatch(loginStart());
  try {
    const res = await axios.post("auth/login", user);
    dispatch(loginSuccess(res.data));
  } catch (err) {
    const errorMessage = err.response?.data?.message || "Login failed. Please check your connection.";
    dispatch(loginFailure(errorMessage));
  }
};